import React from 'react';
import './About.css';
import profile from '../assets/profile.jpg';

function About() {
  return (
    <section id="about" className="about-section">

      <div className="bg-blob bg-blob-1" />
      <div className="bg-blob bg-blob-2" />
      <div className="bg-blob bg-blob-3" />
      <div className="mesh-grid" />

      <div className="about-container">

        {/* ── Left: Image ── */}
        <div className="about-image-wrapper">
          <div className="image-card">
            <div className="floating-shape" />
            <div className="photo-ring" />
            <div className="photo-ring ring-2" />
            <img src={profile} alt="Bibek" className="about-photo" />
          </div>

          <div className="avail-badge">
            <span className="avail-dot" />
            Available for opportunities
          </div>

          <div className="about-stats">
            <div className="stat-item">
              <span className="stat-number">10+</span>
              <span className="stat-label">Projects</span>
            </div>
            <div className="stat-divider" />
            <div className="stat-item">
              <span className="stat-number">1+</span>
              <span className="stat-label">Years</span>
            </div>
            <div className="stat-divider" />
            <div className="stat-item">
              <span className="stat-number">∞</span>
              <span className="stat-label">Curiosity</span>
            </div>
          </div>
        </div>

        {/* ── Right: Text ── */}
        <div className="about-text">

          <div className="eyebrow">
            <span className="eyebrow-pill">About Me</span>
          </div>

          <h2 className="about-heading">
            Turning Data Into
            <span className="gradient-text-highlight"> Meaningful Insights</span>
          </h2>

          <div className="text-divider" />

          <p>
            Bachelor's in <strong>Computer Science</strong> student with a specialization in
            <strong> Data Science</strong>, passionate about transforming data into meaningful
            insights and practical solutions.
          </p>

          <p>
            Strong foundation in programming, data analysis, and machine learning, with
            hands-on experience in <strong>Python</strong>, <strong>SQL</strong>,{' '}
            <strong>data visualization</strong>, and <strong>IoT-based projects</strong>.
            Interested in data-driven decision making, artificial intelligence, and building
            scalable solutions.
          </p>

          <p>
            Actively seeking opportunities in <strong>data science</strong> and{' '}
            <strong>software development</strong> through internships, projects, and
            entry-level roles.
          </p>

          <div className="skill-tags">
            {['Python', 'SQL', 'Machine Learning', 'Data Visualization', 'IoT', 'AI', 'React', 'JavaScript'].map(tag => (
              <span key={tag} className="skill-tag">{tag}</span>
            ))}
          </div>

          {/* ── Experience Block ──
          <div className="exp-section">
            <div className="exp-header">
              <span className="exp-label">Experience</span>
            </div>

            <div className="exp-card">
              <div className="exp-icon">🎓</div>
              <div className="exp-info">
                <span className="exp-role">Fresher — Ready to Join</span>
                <span className="exp-org">Open to Internships & Entry-Level Roles</span>
                <span className="exp-note">
                  No industrial experience yet — but backed by strong academic projects,
                  self-driven learning, and a genuine passion for data science, AI, and
                  web development.
                </span>
              </div>
              <span className="exp-badge">Open</span>
            </div>

            <div className="exp-card">
              <div className="exp-icon">💻</div>
              <div className="exp-info">
                <span className="exp-role">Academic & Personal Projects</span>
                <span className="exp-org">Self-Driven · Ongoing</span>
                <span className="exp-note">
                  Built real-world projects involving data analysis, machine learning models,
                  IoT systems, and full-stack web apps using Python, SQL, and React.
                </span>
              </div>
              <span className="exp-badge">Active</span>
            </div>

            <div className="exp-card">
              <div className="exp-icon">🌐</div>
              <div className="exp-info">
                <span className="exp-role">Web Development</span>
                <span className="exp-org">Frontend & Full-Stack · Ongoing</span>
                <span className="exp-note">
                  Passionate about building responsive, user-friendly web interfaces.
                  Hands-on experience with <strong>React</strong>, <strong>JavaScript</strong>,
                  <strong> HTML</strong>, and <strong>CSS</strong> — focused on clean design,
                  smooth interactions, and real-world usability.
                </span>
              </div>
              <span className="exp-badge exp-badge-web">Exploring</span>
            </div>

          </div> */}

          <div className="btn-group">
            <a href="/Bibek_Khadka_CV_Updated.pdf" className="btn" target="_blank" rel="noopener noreferrer">
              Download CV <span className="btn-arrow">↓</span>
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}

export default About;